const apiOrigin = (import.meta.env.VITE_API_URL || 'https://api.banjinos.com/api').replace(/\/$/, '')

let pendingRequest

export async function submitOrderRequest (payload) {
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(JSON.stringify(payload)))
  const hash = Array.from(new Uint8Array(digest), byte => byte.toString(16).padStart(2, '0')).join('')
  let saved = pendingRequest
  try { saved = JSON.parse(sessionStorage.getItem('b2b-order-request')) || saved } catch { /* Optional browser storage. */ }
  if (saved?.hash !== hash) saved = { hash, key: crypto.randomUUID() }
  pendingRequest = saved
  try { sessionStorage.setItem('b2b-order-request', JSON.stringify(saved)) } catch { /* Request still works. */ }
  const response = await fetch(`${apiOrigin}/v1/order-requests`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ ...payload, submissionKey: saved.key }), signal: AbortSignal.timeout(20000)
  })
  const body = await response.json()
  if (!response.ok || !body.success || !body.data?.reference) throw new Error(body.error || 'We could not confirm the saved request. Retry with the same details.')
  try { sessionStorage.removeItem('b2b-order-request') } catch { /* Optional browser storage. */ }
  pendingRequest = null
  return body.data
}
